import React, { useState, useContext, useEffect } from "react";
import { TimelineContext } from "../../../helpers/Context";
import { isMobile, isDesktop, isIPad13, isTablet } from "react-device-detect";
import useTranslation from "../../../hooks/useTranslation";
import { PlatformMobile } from "../../../helpers/Constants";

const Indicator = ({
  title,
  icon,
  initialState,
  values: propsValues,
  type,
  callBack,
  onClick,
  forceDisable,
  forceStop,
  forceUpdate,
}) => {
  const T = useTranslation();
  const contextTimeline = useContext(TimelineContext);
  const [status, setStatus] = useState(initialState);
  const [values, setValues] = useState(propsValues || []);
  const [typeOfIndeicator, setTypeOfIndicator] = useState(type);

  const handlerOnClick = () => {
    if (forceStop) return;
    if (forceDisable) return;
    if (onClick) {
      onClick([...values]);
    }
  };

  useEffect(() => {
    setTypeOfIndicator(type);
  }, [type]);

  useEffect(() => {
    setValues(propsValues);
  }, [propsValues]);

  useEffect(() => {
    setValues(propsValues);
  }, [forceUpdate]);

  return (
    <>
      <div
        onClick={forceDisable? undefined :  handlerOnClick}
        style={{
          opacity: forceDisable ? "50%" : "100%",
          background: forceDisable ? "#F5FBFA" : "#fff",
        }}
        className={`p-[10px] bg-white mt-[1%] rounded-[10px] flex flex-1 flex-col items-center opacity-[${
          status ? "100%" : "50%"
        }] ${forceDisable ? "" : "cursor-pointer shadow shadow-[#2AAC9C4D]"}  `}
      >
        <div className="flex p-1 items-center gap-2 justify-between w-full">
          <div
            className="text-black select-none flex flex-col p-1 justify-center w-4/6 font-[700] leading-tight line-clamp-2"
            style={{
              fontSize: isTablet
                ? "clamp(12px, 2vw, 18px)"
                : "clamp(10px, 4vw, 12px)",
            }}
          >
            {T(title)}
          </div>
          <div
            style={{
              background: forceDisable ? "transparent" : "#FEEFF2",
              height: isTablet ? "48px" : "36px",
              aspectRatio: 1,
            }}
            className="flex select-none items-center justify-center w-2-6 rounded bg-[#fff] rounded-[8px] p-[4px]"
          >
            <img src={icon} alt={icon} />
          </div>
        </div>
        <div className="flex flex-1 p-1 items-end justify-start gap-2 w-full">
          <div className="flex flex-1 p-1 items-center  w-full ">
            {values?.map((item, indx) => {
              return (
                <div
                  key={`indicator-${indx}-${item.title}`}
                  className="flex jusfity-center  items-center mr-2 gap-2"
                >
                  <div
                    className={`min-h-[10px] min-w-[10px]${
                      item.status ? " bg-[#2AAC9C]" : " bg-gray-300"
                    } rounded-full `}
                  ></div>

                  <span className=" text-xs  select-none text-clip overflow-hidden ...">
                    {T(item.title)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Indicator;
